import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import ChatPageUI from './ChatPageUI'

class ChatPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      chatUser: null
    }
  }

  render() {
    return (
      <ChatPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        chatUser={this.state.chatUser}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getChatUser(context)
  }

  getChatUser(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/chatUser`,
      cacheKey: CacheKeys.ChatUser(),
      callback: this.getChatUserCallback,
      ttlInSecs: 10
    })
    cacheManager.getObject2(context)
  }

  getChatUserCallback = (response) => {
    this.setState({chatUser: response.chatUser, errorList: response.errorList})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ChatUser())
    this.setState({
      errorList: null,
      chatUser: null,
    }, () => {
      this.getChatUser(context)
    })
  }
}

export default ChatPageSF
